import Flag from './Flag';

export default Flag;
export { default as FlagWithCountry } from './FlagWithCountry';
